import { fetchAPI } from "../../../../../config/axios";
import {
  UpayaPengelolaanRisikoAction,
  UpayaPengelolaanRisikoActionType,
  UpayaPengelolaanRisikoDataModel,
} from "./types";

export const UpayaPengelolaanRisiko: UpayaPengelolaanRisikoDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const UpayaPengelolaanRisikoReducer = (
  state: UpayaPengelolaanRisikoDataModel = UpayaPengelolaanRisiko,
  action: UpayaPengelolaanRisikoAction
): UpayaPengelolaanRisikoDataModel => {
  switch (action.type) {
    case UpayaPengelolaanRisikoActionType.GetUpayaPengelolaanRsiiko:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const UpayaPengelolaanRisikoCommand = {
  GetUpayaPengelolaanRisiko: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaian/upaya-pengelolaan-risikos",
          { params }
        );
        dispatch({
          type: UpayaPengelolaanRisikoActionType.GetUpayaPengelolaanRsiiko,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateUpayaPengelolaanRisiko: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian/upaya-pengelolaan-risiko",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateUpayaPengelolaanRisiko: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian/upaya-pengelolaan-risiko",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteUpayaPengelolaanRisiko: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-parameter-penilaian/upaya-pengelolaan-risiko",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
